import React from 'react';
import {MobileView, BrowserView} from "react-device-detect";

export const Footer: React.FC = () => {
    return (
        <>
        <MobileView>
            <div style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'flex-start',
                justifyContent: 'center',
                backgroundColor: 'rgb(0, 4, 255)',
            }}>
                <div style={{
                    marginTop: '40px',
                    marginBottom: '30px',
                    display: 'flex',
                    paddingLeft: '25px',
                    paddingRight: '25px',
                    textAlign: 'center',
                    fontSize: '1.1rem',
                }}>
                    1977 Frankfort Street, San Diego, CA 92110
                </div>
                <div style={{
                    display: 'flex',
                    width: '100%',
                    marginBottom: '35px',
                    textAlign: 'center',
                    justifyContent: 'center',
                    fontSize: '0.8rem',
                }}>
                    © 2025 Haku Technology. All rights reserved.
                </div>
            </div>
        </MobileView>
            <BrowserView>
                <div style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'flex-start',
                    justifyContent: 'center',
                    backgroundColor: 'rgb(0, 4, 255)',
                }}>
                    <div style={{
                        marginTop: '80px',
                        marginBottom: '5px',
                        display: 'flex',
                        marginLeft: '75px'
                    }}>10531 4S Commons Dr., Suite 166, San Diego, CA 92130
                    </div>
                    <div style={{
                        display: 'flex',
                        marginBottom: '35px',
                        marginLeft: '75px'
                    }}>© 2025 Haku Technology. All rights reserved.
                    </div>
                </div>
            </BrowserView>
        </>
    );
};


